<!-- CmmQuestionnaireAttachment.vue -->
<script lang="ts" setup>
    import '../../../../../css/choice.css'
    import { IntDatabaseIdAndNameModel } from '../../../../lib/Models/IntDatabaseIdAndNameModel';
    import { reactive } from 'vue';
    import { confirmDialog } from '../../../../lib/Notification';
    import { DisplayStyle, IconTypes } from '../../../../Enums/UiEnums';
    import Icon from '../../../../components/Icon.vue';
    import ModalDialog from '../../../../components/ModalDialog.vue';
    import CmmQuestionnaireAttachmentSelection from './CmmQuestionnaireAttachmentSelection.vue';
    import MessageBadge from '../../../../components/Messages/MessageBadge.vue';
    import { ChoiceApi } from '../../../../LibMain';

    const props = withDefaults(defineProps<{
        patientId: number,
        attachmentId?: IntDatabaseIdAndNameModel,
        indicateRequired?: boolean,
        allowRemoval?: boolean,
        allowAttachment?: boolean
    }>(), {
        indicateRequired: false,
        allowRemoval: false,
        allowAttachment: true
    });

    const emits = defineEmits<{
        "update:attachmentId": [attachmentId?: IntDatabaseIdAndNameModel]
    }>();

    const compData = reactive<{
        showAttachmentModal?: boolean        
    }>({});

    function onClickAddAttachmentIcon()
    {
        compData.showAttachmentModal = true;
    }

    function onAddAttachment(attachmentId: IntDatabaseIdAndNameModel)
    {
        emits("update:attachmentId", attachmentId);
        compData.showAttachmentModal = false;
    }

    async function deleteAttachment()
    {
        if (!props.allowRemoval)
            return;
        if (await confirmDialog('Remove attachment'))
        {
            emits("update:attachmentId", undefined);
        }
    }

</script>

<template>
    <!-- Questionnaire level attachment -->
    <span v-if="!props.attachmentId && props.allowAttachment" 
            class="pointer"
            title="Add attachment"
            @click="onClickAddAttachmentIcon" >
        <Icon :icon="IconTypes.Attach" class="me-1"/>

        <span v-if="props.indicateRequired" class="ms-2">
            <MessageBadge :displayStyle="DisplayStyle.Danger">
                Required
            </MessageBadge>
        </span>

    </span>

    <template v-if="props.attachmentId">
        <span class="pointer me-1" title="Remove attachment" @click="deleteAttachment()">
            <Icon :icon="IconTypes.Delete" v-if="allowRemoval"/>
        </span>
        
        <a :href="ChoiceApi.coverMyMeds.getAttachmentUrl(props.attachmentId?.idType, props.attachmentId?.id)" target="_blank">
            {{ props.attachmentId.name }}
        </a>
    </template>


    <ModalDialog v-model:show="compData.showAttachmentModal" :closeOnClickOutside="false">
        <template #title>Add Attachment</template>

        <CmmQuestionnaireAttachmentSelection 
                v-if="compData.showAttachmentModal"
                :patientId="props.patientId"
                @attach="onAddAttachment" />
    </ModalDialog>    
</template>